import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('applications')
export class Application{
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id:number;
    @Column('varchar', {
        nullable: false,
        length:50,
        name: 'company_name',
    })
    companyName: string;
    @Column('simple-array', {
        nullable: false,
        name: 'module_name',
    })
    moduleName: string[];
}